<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading" class="w-full min-w-0 max-w-full [container-type:inline-size]">
    <div class="flex gap-0 cursor-pointer">
        <p class="font-semibold text[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] dark:bg-blacks">Distribution Centres
        </p>
    </div>

    <div class="w-full min-w-0 px-10 py-7 [@container(max-width:640px)]:px-4 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg">
        <div class="flex flex-row items-center justify-between gap-x-8 gap-y-4 w-full min-w-0 [@container(max-width:760px)]:flex-wrap">
            <div class="flex flex-col justify-between flex-shrink-0">
                <p class="font-semibold md:text-lg lg:text-lg mb-1 dark:text-white whitespace-nowrap">Centres
                    ({{totalItems < 10 ? '0' + totalItems : totalItems}})</p>
            </div>
            <div class="flex flex-row items-center justify-end gap-4 flex-1 min-w-0 [@container(max-width:760px)]:basis-full [@container(max-width:760px)]:flex-wrap [@container(max-width:760px)]:justify-start">
                <i class="fa-solid fa-list text-[#4A4A4A] text-lg dark:text-white flex-shrink-0 ml-5 [@container(max-width:760px)]:ml-0"></i>
                <p class="text-[#4A4A4A] dark:text-white whitespace-nowrap flex-shrink-0 mr-1">Filter By</p>

                <div class="flex gap-4 flex-shrink-0 [@container(max-width:760px)]:w-full [@container(max-width:480px)]:flex-col">


                    <div class="relative w-44 rounded-lg flex-shrink-0 mr-1 [@container(max-width:760px)]:w-auto [@container(max-width:760px)]:flex-1 [@container(max-width:760px)]:min-w-0 [@container(max-width:760px)]:mr-0">
                        <app-searchable-dropdown id="province" name="province" [items]="provinceItems"
                            [placeholder]="'Province'" [searchPlaceholder]="'Search...'" [(ngModel)]="selectProvince"
                            #provinceInput="ngModel" (ngModelChange)="filterProvince($event)"></app-searchable-dropdown>
                    </div>

                    <div class="relative w-44 rounded-lg flex-shrink-0 mr-1 [@container(max-width:760px)]:w-auto [@container(max-width:760px)]:flex-1 [@container(max-width:760px)]:min-w-0 [@container(max-width:760px)]:mr-0">
                        <app-searchable-dropdown id="district" name="district" [items]="districtItems"
                            [placeholder]="'District'" [searchPlaceholder]="'Search...'" [(ngModel)]="selectDistrict"
                            #districtInput="ngModel" (ngModelChange)="filterDistrict($event)"></app-searchable-dropdown>
                    </div>
                </div>

                <div
                    class="flex items-center rounded-full px-4 py-2 flex-1 min-w-0 max-w-xs [&_button]:shrink-0 [@container(max-width:760px)]:basis-full [@container(max-width:760px)]:max-w-none bg-[#F1F1F1] dark:bg-[#292929]">
                    <input type="text" placeholder="Search by Reg Code / Centre Name.." [(ngModel)]="searchText"
                        title="Search by Reg Code or Centre Name"
                        class="bg-transparent outline-none w-full min-w-0 text-textLight dark:text-textDark"
                        (keydown.enter)="onSearch()" (keydown.esc)="offSearch()" />
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                        (click)="onSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                        </svg>
                    </button>
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                        (click)="offSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <div class="flex flex-row flex-wrap gap-4">
            <div class="flex flex-row mt-3 mb-0">
                <button class="bg-[#415CFF] text-white font-semibold px-4 py-2 rounded-lg shadow-lg"
                    (click)="addCenter()">Add a
                    Centre</button>
            </div>

            <div class="flex flex-row mt-3 mb-0">
                <button class="bg-[#415CFF] text-white font-semibold px-4 py-2 rounded-lg shadow-lg"
                    (click)="navigateToAssignCities()">
                    Assign Cities</button>
            </div>
        </div>

        <div *ngIf="hasData" class="mt-5 min-w-0 max-w-full">
            <div class="overflow-auto max-h-[max(365px,calc(100vh-400px))] border-gray-100 border-[2px] dark:border-[#202021] rounded-lg">
                <table class="w-full min-w-max divide-y-2">
                    <thead
                        class="sticky top-0 z-20 bg-white text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] cursor-default">
                        <tr>
                            <th class="[@container(max-width:640px)]:static sticky left-0 bg-white dark:bg-[#0F0F0F] px-6 py-3 text-left font-normal w-20 min-w-20">No</th>
                            <th class="[@container(max-width:640px)]:static sticky left-20 bg-white dark:bg-[#0F0F0F] px-6 py-3 text-left font-normal w-40 min-w-40 whitespace-nowrap">Reg Code</th>
                            <th class="[@container(max-width:640px)]:static sticky left-60 bg-white dark:bg-[#0F0F0F] px-6 py-3 text-left font-normal w-56 min-w-56">Centre Name</th>
                            <th class="px-6 py-3 text-left font-normal w-28">Province</th>
                            <th class="px-6 py-3 text-left font-normal w-28">District</th>
                            <th class="px-6 py-3 text-left font-normal w-28">City</th>
                            <th class="px-6 py-3 text-center font-normal w-40">Contact Number -1</th>
                            <th class="px-6 py-3 text-center font-normal w-40">Location</th>
                            <th class="px-6 py-3 text-center font-normal w-32">DCM Profiles</th>
                            <th class="px-6 py-3 text-center font-normal w-32">DIO Profiles</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="countOfOfficers != 0" class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                        <tr class="group hover:bg-[#415CFF] hover:text-white dark:text-gray-300 cursor-pointer"
                            *ngFor="let item of itemsArr | paginate : { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalItems }; let i = index"
                            (click)="navigateToDashboard(item.centerId, item.centerName, item.regCode)">
                            <td class="[@container(max-width:640px)]:static sticky left-0 z-10 bg-white dark:bg-[#1D1D1F] group-hover:bg-[#415CFF] px-6 py-3 font-medium text-center">
                                {{ ('0' + ((currentPage - 1) * itemsPerPage + i + 1)).slice(-2) }}
                            </td>
                            <td class="[@container(max-width:640px)]:static sticky left-20 z-10 bg-white dark:bg-[#1D1D1F] group-hover:bg-[#415CFF] px-6 py-3 font-medium text-left break-all">{{ item.regCode }}</td>
                            <td class="[@container(max-width:640px)]:static sticky left-60 z-10 bg-white dark:bg-[#1D1D1F] group-hover:bg-[#415CFF] px-6 py-3 font-medium text-left">{{ item.centerName }}</td>
                            <td class="px-6 py-3 font-medium text-left">{{ item.province }}</td>
                            <td class="px-6 py-3 font-medium text-left">{{ item.district }}</td>
                            <td class="px-6 py-3 font-medium text-left">{{ item.city }}</td>
                            <td class="px-6 py-3 font-medium text-center">
                                <ng-container *ngIf="item.contact01; else noContact">
                                    {{ '+94' + item.contact01 }}
                                </ng-container>
                                <ng-template #noContact>
                                    N/A
                                </ng-template>
                            </td>
                            <td class="px-6 py-3 font-medium text-center">
                                <a *ngIf="item.longitude && item.latitude" href="https://www.google.com/maps?q={{ item.latitude }},{{
                      item.longitude
                    }}" target="_blank" class="text-red-600 hover:text-blue-800 text-xl" title="View on map"
                                    (click)="$event.stopPropagation()">
                                    <i class="fas fa-map-marker-alt"></i>
                                    <!-- Font Awesome map pin icon -->
                                </a>
                                <span *ngIf="!item.longitude || !item.latitude" class="text-gray-400">
                                    <i class="fas fa-map-marker-alt"></i>
                                    <!-- Disabled/grayed out icon when no coordinates -->
                                </span>
                            </td>
                            <td class="px-6 py-3 font-medium text-center">{{ item.distributionCenterManagerCount }}</td>
                            <td class="px-6 py-3 font-medium text-center">{{ item.distributionOfficerCount }}</td>
                        </tr>
                    </tbody>
                </table>


            </div>
            <div *ngIf="hasData" class="flex justify-end items-center my-5 pt-3 dark:bg-[#1D1D1F] text-right">
                <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true"
                    [previousLabel]="'Previous'" [nextLabel]="'Next'" [screenReaderPaginationLabel]="'Pagination'"
                    [screenReaderPageLabel]="'page'" [screenReaderCurrentLabel]="'Youre on page'">
                </pagination-controls>
            </div>
        </div>



        <div *ngIf="!hasData"
            class="flex flex-col items-center w-full h-screen px-10 py-7 bg-tileLight dark:bg-[#363636] dark:text-textDark mt-6">
            <p class="text-[#494949] my-6 dark:text-textDark">--No Data Availabale--</p>
            <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20 dark:text-textDark" />
        </div>


    </div>
</div>
